<template>
  <div class="menu-section">
    <div class="section-title">Outros</div>
    <div v-for="(item, index) in menuList" :key="index">
      <div class="menu-card" @click="onMenuClick(item.path, index)" :class="{ 'pop-animate': poppingIndex === index }"
        v-if="checkMenuShow(index)">
        <div class="menu-left">
          <img :src="item.img" alt="" class="menu-icon" />
          <span class="menu-text">{{ $t(item.name) }}</span>
          <div v-if="item.msg" class="sub_text">{{ $t(item.msg) }}</div>
        </div>

        <img src="@/assets/profile/arrow_right_white45.png" alt="" class="arrow-icon" />
      </div>
    </div>
  </div>


  <ContactServicePopup ref="contactServiceRef" />
</template>

<script setup lang="ts">
import { ref, defineEmits, inject } from 'vue'
import { useRouter } from 'vue-router'
import { clickOnMenu, MENU_LIST_THEME_TWO } from '@/view/profile/supportScript'
import ContactServicePopup from '@/view/profile/contactServicePopup.vue'
import { useActivityStore } from '@/stores/activity'
const activityStore = useActivityStore()
const router = useRouter()
const menuList = ref(MENU_LIST_THEME_TWO)
const contactServiceRef = ref()
const poppingIndex = ref<number | null>(null)
const emits = defineEmits(['logout'])
const openLogoutPopup = inject<() => void>('openLogoutPopup')

const handleLogoutClick = () => {
  openLogoutPopup?.()
}

const onMenuClick = (path: string | null, index: number) => {
  clickOnMenu(router, poppingIndex, contactServiceRef, handleLogoutClick, path, index)
}

const checkMenuShow = (index: number) => {
  if (index === 2) {
    const isAvailableRedeem = activityStore.activityList.some((obj: any) => obj.name === "redeem_code")
    if (isAvailableRedeem) {
      return true
    } else {
      return false
    }
  }

  return true
}
</script>

<style scoped>
.menu-section {
  /* background-color: #1b151f; */
  /* padding: 15px; */
  border-radius: 10px;
  margin: 15px;
}

.section-title {
  color: #fff;
  font-size: 14px;
  margin-bottom: 12px;
  font-weight: bold;
}

.menu-card {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: #312734;
  padding: 15px;
  border-radius: 6px;
  margin-bottom: 10px;
  transition: all 0.2s;
  cursor: pointer;
}

.menu-card:hover {
  background-color: #352c3d;
}

.menu-left {
  display: flex;
  align-items: center;
  width: 100%;
}

.sub_text {
  font-size: 10px;
  text-align: right;
  width: 100%;
  margin-right: 10px;
  color: #8047a2;
}

.menu-icon {
  width: 22px;
  height: 22px;
  margin-right: 10px;
}

.menu-text {
  color: #ffffff;
  font-size: 14px;
}

.arrow-icon {
  width: 12px;
  opacity: 0.8;
}

.pop-animate {
  animation: pop-scale 0.25s ease;
}

@keyframes pop-scale {
  0% {
    transform: scale(1);
  }

  50% {
    transform: scale(0.96);
  }

  100% {
    transform: scale(1);
  }
}
</style>
